import React, { Component } from "react"
import { InputCustom, SelectCustom, HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"
import { LoadModal } from "../modais"
export default class RelatorioBaixasForm extends Component {
  constructor() {
    super()
    this.onChangeId = this.onChangeId.bind(this)
    this.getContratos = this.getContratos.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.onChangeGroupBy = this.onChangeGroupBy.bind(this)
    this.state = {
      showLoad: false,
      dataDeInicio: "",
      dataFinal: "",
      formError: "",
      id: "",
      modalidades: [],
      tipos: []
    }
  }
  componentWillMount() {
    this.getContratos()
  }
  getContratos() {
    ApiHelper.getCreateFieldsContrato((data, error) => {
      if (data) {
        this.setState({
          modalidades: data.modalidades,
          tipos: data.tipos
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  onChangeGroupBy(e) {
    this.setState({
      groupBy: e.target.value
    })
  }
  onChangeId(e) {
    var newValue = e.target.value
    this.setState({
      id: newValue
    })
  }
  sendForm(event) {
    event.preventDefault()
    var params = {
      tipo_relatorio: "Contratos agrupados por tipo ou modalidade",
      id: this.state.id === "" ? undefined : this.state.id,
      group_by: this.state.groupBy
    }
    this.toggleLoadModal()
    ApiHelper.getRelatorioWith(params, relatorio => {
      this.toggleLoadModal()
      if (relatorio) {
        var url = URL.createObjectURL(relatorio)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute(
          "download",
          `Relatório de contratos agrupados por ${this.state.groupBy}.pdf`
        )
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.setState({
          formError: "Não existem baixas nesse período"
        })
      }
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="row card" style={{ marginTop: 100 }}>
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="container card">
        <div className="row ">
          <LoadModal
            onClose={this.toggleLoadModal}
            show={this.state.showLoad}
          />
          <InputCustom
            error={this.state.num_contratoError}
            sizeClass="col-md-4"
            label="Agrupar por tipo de contrato"
            type="radio"
            name="group_by"
            checked={this.state.groupBy === "tipo"}
            onChange={this.onChangeGroupBy}
            value="tipo"
          />
          <InputCustom
            error={this.state.num_contratoError}
            sizeClass="col-md-4"
            label="Agrupar por modalidade"
            type="radio"
            name="group_by"
            onChange={this.onChangeGroupBy}
            checked={this.state.groupBy === "modalidade"}
            value="modalidade"
          />
        </div>
        {this.state.groupBy && (
          <div className="row">
            {this.state.groupBy === "modalidade" ? (
              <SelectCustom
                sizeClass="col-md-8"
                options={this.state.modalidades}
                label="Modalidade"
                onChange={this.onChangeId}
                value={this.state.id}
              />
            ) : (
              <SelectCustom
                sizeClass="col-md-8"
                options={this.state.tipos}
                label="Tipo"
                onChange={this.onChangeId}
                value={this.state.id}
              />
            )}
          </div>
        )}
        {this.state.groupBy && (
          <div className="row">
            <button
              style={{ margin: 20 }}
              onClick={this.sendForm}
              type="submit"
              className="btn btn-primary pull-left"
              data-background-color="as-blue"
            >
              Gerar
            </button>
          </div>
        )}

        <span style={{ margin: 20 }} className="label label-primary">
          PS:Se não for selecionado modalidade/tipo todos serão contemplados
        </span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/relatorios/RelatorioContratosGroupedByForm.js